import { render, staticRenderFns } from "./Wetalkie.vue?vue&type=template&id=11fc4311&scoped=true&"
import script from "./Wetalkie.vue?vue&type=script&lang=js&"
export * from "./Wetalkie.vue?vue&type=script&lang=js&"
import style0 from "./Wetalkie.vue?vue&type=style&index=0&id=11fc4311&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fc4311",
  null
  
)

export default component.exports